// Cartas na web: SEMPRE a imagem exportada pelo renderizador do Godot (CardView), nunca redesenhada em HTML.
// Princípio "um sítio para cada coisa" (docs/PLATAFORMA.md §3.7, ADR P8).
import { aspects, rarities, type Aspect, type Rarity } from "@ecliptica/tokens";
import { cn } from "@ecliptica/ui";
import { createContext, useContext, type ComponentProps, type ReactNode } from "react";

/** Onde estão as imagens das cartas (W0: pasta local; W5+: R2, com versão de conteúdo). */
const CardAssetsContext = createContext<{ baseUrl: string; version?: string }>({ baseUrl: "/cards" });

export function CardAssetsProvider({ baseUrl, version, children }: { baseUrl: string; version?: string; children: ReactNode }) {
  return <CardAssetsContext.Provider value={{ baseUrl, version }}>{children}</CardAssetsContext.Provider>;
}

export function cardImageUrl(baseUrl: string, id: string, lang: string, version?: string) {
  return `${baseUrl.replace(/\/$/, "")}/${lang}/${encodeURIComponent(id)}.webp${version ? `?v=${version}` : ""}`;
}

export function CardImage({ id, lang, alt, className, ...props }: { id: string; lang: string; alt: string } & Omit<ComponentProps<"img">, "src">) {
  const { baseUrl, version } = useContext(CardAssetsContext);
  return (
    <img
      src={cardImageUrl(baseUrl, id, lang, version)}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={cn("aspect-[5/7] w-full rounded-[4.5%] object-cover shadow-panel", className)}
      {...props}
    />
  );
}

export function AspectDot({ aspect, className }: { aspect: Aspect; className?: string }) {
  return <span className={cn("inline-block size-2.5 rounded-full", className)} style={{ background: aspects[aspect] }} />;
}

export function RarityGem({ rarity, className }: { rarity: Rarity; className?: string }) {
  return <span className={cn("inline-block size-2.5 rotate-45 rounded-[2px]", className)} style={{ background: rarities[rarity] }} />;
}
